import React from "react"
import styles from './footer.module.css'
import phone from "./images/phone.svg"
import map from "./images/map.svg"
import vk from "./images/vk.svg"
import tg from "./images/tg.svg"
import inst from "./images/inst.svg"
import {Link} from "react-router-dom";
import {FadeIn} from "../../shared/ui/animations";

const Footer = () => {
    return (
        <FadeIn>
            <footer className={styles.footer}>
                <div className={`container-custom my-0 row g-0`}>
                    <a href="/#main-page" className="col-md-6">
                        <img className={styles.footerLogo} src="/images/logo-green.svg" alt=""/>
                    </a>
                    <div className={styles.contactsWrapper + " col-md-6 row g-0"}>
                        <div className={`${styles.contacts} col-md`}>
                            <h4>Контакты</h4>
                            <div>
                                <p className={`body d-flex align-items-center ${styles.mb1}`}>
                                    <img src={phone} className={styles.contactsImg} alt="Телефон"/>
                                    <a className={styles.contactLink} href="tel:+79616425767">+7 (961) 642-57-67</a>
                                </p>
                                <p className="body d-flex align-items-center">
                                    <img src={map} className={styles.contactsImg} alt="Точка на карте"/>
                                    <a className={styles.contactLink} href="https://www.google.ru/maps/place/ул.+Кутякова,+4,+Саратов,+Саратовская+обл.,+410003/@51.5351371,46.033386,15.86z/data=!4m6!3m5!1s0x4114c7c3c628d253:0x25b2569e368b8198!8m2!3d51.5353291!4d46.0376459!16s%2Fg%2F11bw3yhvj6?entry=ttu&g_ep=EgoyMDI1MDQyOS4wIKXMDSoASAFQAw%3D%3D">улица имени И.С. Кутякова,4, Саратов</a>
                                </p>
                            </div>
                        </div>
                        <div className={`${styles.socialWrapper} col-md`}>
                            <div className={styles.social}>
                                <a target={"_blank"} href="https://vk.com/podzemelie_saratov" rel="noreferrer"><img src={vk}  alt="Наш ВКонтакте"/></a>
                                <a target={"_blank"} href="https://t.me/podzemelie_saratov" rel="noreferrer"><img src={tg} alt="Наш Телеграм"/></a>
                                <a target={"_blank"} href="https://www.instagram.com/podzemelie_saratov?igsh=cHF2cGU2b3Bldndi&utm_source=qr" rel="noreferrer"><img src={inst} alt="Наш Инстаграм"/></a>
                            </div>
                            <Link to={'/privacy'} className={styles.policy}>Политика Конфиденциальности</Link>
                        </div>
                    </div>
                </div>
            </footer>
        </FadeIn>
    )
}

export default Footer